import { render, staticRenderFns } from "./ClienteDetalle.vue?vue&type=template&id=21bea5a4&scoped=true"
import script from "./ClienteDetalle.vue?vue&type=script&lang=js"
export * from "./ClienteDetalle.vue?vue&type=script&lang=js"
import style0 from "./ClienteDetalle.vue?vue&type=style&index=0&id=21bea5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bea5a4",
  null
  
)

export default component.exports